<div *ngIf="data" [style.width.px]="data.width+50" class="content">
    <owl-carousel-o id="carousel" [options]="customOptions" #owlCar>
        <ng-container *ngFor="let el of data.carousel">
            <ng-template carouselSlide>
                <img class="ad-image" [src]='el.finalImgUrl' alt="">
            </ng-template>
        </ng-container>
    </owl-carousel-o>
</div>